module.exports = __webpack_public_path__ + "public/SiteIcons/profileEditIcon.svg?c6b462ba";